// Centralised brand label. Override at build time via
//   REACT_APP_BRAND_NAME=...   (in adminpanel/.env)
// so every "MyDr.Ai" in the UI changes with a single env edit.
export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'MyDr.Ai';
